import { useGraphQLContext } from "../../context/graphQLContext";
import { useQuery } from "@tanstack/react-query";
import request from "graphql-request";
import { getGlobalNote } from "../../queries/notes";

export type GlobalNote = {
    globalsEntries: Array<{ noteColor: string; noteText: string }>;
};

export const useGetGlobalNote = () => {
    const graphqlOptions = useGraphQLContext();
    return useQuery<GlobalNote>({
        queryKey: ["globalNotes"],
        queryFn: async () => {
            return request({
                ...graphqlOptions,
                document: getGlobalNote,
            });
        },
        keepPreviousData: true,
        refetchOnWindowFocus: false,
    });
};
